interface IFormWrapperProps extends IChildren {
  className: string;
  title: string;
}
function FormWrapper({ className, title, children }: IFormWrapperProps) {
  return (
    <div className={className}>
      <h4>{title}</h4>
      {children}
    </div>
  );
}

export default FormWrapper;
